export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
      default: 0,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
};
